import { ITask } from '@modules/TasksModule/types';
import { throttle } from 'lodash';
import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import addFollowUpInteraction from './lib/addFollowUpInteraction';
import TasksModule from '@modules/TasksModule';

export class UrgentFollowUpsModule extends AppModule {
  private throttledHandleTaskUpdated: any;

  override preload(): void {
    this.throttledHandleTaskUpdated = throttle(
      this.handleTaskUpdated.bind(this),
      3000,
    );

    this.app.events.on('task.updated', async ({ task }: { task: ITask }) => {
      await this.throttledHandleTaskUpdated(task);
    });
  }

  private async handleTaskUpdated(task: ITask) {
    if (!task.attributes.interactionId) {
      return;
    }
    if (!task.attributes.followUp?.id) {
      return;
    }
    if (task.attributes.followUp?.added) {
      return;
    }

    try {
      this.app.logger.info('Add followUp interaction', task.id, task.state);
      await addFollowUpInteraction(task.attributes.followUp.id, {
        id: task.attributes.interactionId,
      });
      TasksModule.setTaskAttribute(task.id, 'followUp', {
        ...task.attributes.followUp,
        added: true,
      });
    } catch (e) {
      this.app.logger.error('Error adding followup interaction', e);
    }
  }
}

export default new UrgentFollowUpsModule(
  appManager.events,
  appManager.logger('UrgentFollowUps'),
);
